module.exports = __webpack_public_path__ + "media/img/masks/avatar-status-508b8ad68f92fdbae5a686ca90ed94c0.svg";